<div class="modal-content">
  <div class="modal-header">
    <h1 class="modal-title pull-left">{{ title | globalTranslate }}</h1>
    <button
      type="button"
      class="btn-close pull-right"
      [attr.aria-label]="'CLOSE' | globalTranslate"
      (click)="onCancel()"
    >
      <img
        src="../../assets/images/⚛️ icons-close-circle-outline.svg"
        alt="close-icon"
        aria-hidden="true"
        role="presentation"
      />
    </button>
  </div>
  <div class="modal-body">
    <h2 class="page-header sr-only" role="heading" aria-level="1">
      {{ title | globalTranslate }}
    </h2>
    <mat-accordion displayMode="" multi>
      @for (status of currentStatus; track status) {
      <mat-expansion-panel
        (opened)="status.expanded = true"
        (closed)="status.expanded = false"
      >
        <mat-expansion-panel-header
          role="button"
          class="mat-row"
          hideToggle
          [attr.aria-expanded]="status.expanded || false"
          [attr.aria-label]="
            (status?.title | globalTranslate) +
            (status.expanded
              ? ', ' + ('EXPANDED' | globalTranslate)
              : ', ' + ('COLLAPSED_CLICK_TO_EXPAND' | globalTranslate))
          "
        >
          <mat-panel-title>
            <h2 class="title">{{ status?.title | globalTranslate }}</h2>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="description">
          <p [innerHTML]="status?.description | globalTranslate"></p>
        </div>
        <hr />
      </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
</div>